// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wiglett: PokeData = {
  "id": 960,
  "name": "wiglett",
  "height": 12,
  "weight": 18,
  "base_experience": 49,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "slam",
    "sand-attack",
    "headbutt",
    "wrap",
    "water-gun",
    "dig",
    "mud-slap",
    "water-pulse",
    "sucker-punch",
    "aqua-jet",
    "throat-chop",
    "liquidation"
  ],
  "moves": [
    "headbutt",
    "mud-slap",
    "aqua-jet",
    "liquidation",
    "bubble",
    "brine",
    "rain-dance",
    "bubble-beam",
    "aqua-tail",
    "aqua-cutter",
    "life-dew",
    "water-spout",
    "hydro-pump"
  ],
  "evolution_chain": {
    "id": 502,
    "item": null,
    "species": [
      {
        "name": "wiglett",
        "order": 929,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wugtrio",
        "order": 930,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 960,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 17.5,
    "speed": 95,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
